import React, {
  useCallback,
  useEffect,
  useMemo
} from 'react'
import {
  Button,
  Form
} from 'semantic-ui-react'
import filter from 'lodash/filter'
// Local
import * as c from '../../../constant'
import If from '../../common/if'
import {
  CONDITION,
  shouldRenderReskin2025
} from '../../../constant'
import ReveleerButton from '../../common/ReveleerButton'

type Rule = {
  id: string | undefined
  ruleType: string
  type: string | undefined
  title: string
  statusCode: keyof typeof CONDITION.STATUS
  reason: string
}

export const NEW_RULE = 'NEW_RULE'

type Props = {
  onChangeValue: any
  rules: Rule[]
}

// TODO - sboles - Refactor! This needs to be a component
//      - This needs to be entirely refactored. Make it a component that has
//        state. The current implementation causes the parent component to
//        mutate state during its render when this thing renders with an initial
//        empty rule row
function ReasonHandler(
  props: Props
) {
  const {
    rules = [],
    onChangeValue
  } = props

  const onChangeRule = (
    ruleToUpdate: Rule,
    event: any,
    data: { value: string }
  ) => {
    const updatedRules = rules.map((rule: any) =>
      rule.id === ruleToUpdate.id
        ? {
          ...rule,
          reason: data.value
        }
        : rule)
    onChangeValue(
      null,
      {
        name: 'rules',
        value: updatedRules
      }
    )
  }

  const addRow = useCallback(() => {
    const newRules = [
      ...rules,
      {
        type: NEW_RULE,
        reason: '',
        id: Math.random()
      }
    ]
    onChangeValue(
      null,
      {
        name: 'rules',
        value: newRules
      }
    )
  }, [ rules, onChangeValue ])

  const color = shouldRenderReskin2025
    ? undefined
    : 'blue'

  const className = shouldRenderReskin2025
    ? 'reskin secondary'
    : ''

  const createRow = (
    rule: Rule,
    lastRow: boolean
  ) => (
    <div key={ rule.id }>
      <Form.Group widths="equal">
        <Form.Input
          name="reason"
          placeholder="Reason"
          value={ rule.reason }
          onChange={
            (
              event: any,
              data: { value: string }
            ) => onChangeRule(
              rule,
              event,
              data
            )
          }
        />
      </Form.Group>
      <If isTrue={ lastRow }>
        <div className="add-button">
          <If isTrue={ !shouldRenderReskin2025 }>
            <Button
              className={ className }
              color={ color }
              id="add-more-button"
              type="button"
              onClick={ addRow }
            >
              Add More
            </Button>
          </If>
          <If isTrue={ shouldRenderReskin2025 }>
            <ReveleerButton
              buttonLabel="Add More"
              buttonSize="small"
              buttonType="secondary"
              id="add-more-button"
              isDisabled={ false }
              onClick={ addRow }
              type="button"
            />
          </If>
        </div>
      </If>
    </div>
  )

  const activeRules = useMemo(
    () => filter(
      rules,
      rule => rule.statusCode === c.CONDITION.STATUS.ACTIVE || rule.type === NEW_RULE
    ),
    [ rules ]
  )

  useEffect(() => {
    if (activeRules.length === 0) {
      addRow()
    }
  }, [ activeRules.length, addRow ])

  const rowLen = activeRules.length

  return (
    <div className="reason">
      {
        activeRules.map((rule: Rule, count: number) => createRow(rule, rowLen === count + 1))
      }
    </div>
  )
}

export default ReasonHandler
